module.exports = __webpack_public_path__ + "img/banner_left.fee25891.png";